import React from "react";
import styled from "styled-components";
import { styles } from "../../styles";
import { UnstyledButton } from "./UnstyledButton";

export {
  CalculatorIcon,
  SuccessIcon,
  EyeClosedIcon,
  EyeOpenIcon,
  ResetIcon,
  RotateScreenIcon,
  ScreenDimensionsIcon,
  ScreenshotSavedCheckmark,
  CaretDownIcon,
  CaretUpIcon,
  CheckedIcon,
  CloseIcon,
  CommunicationIcon,
  DownloadIcon,
  HomeIcon,
  ScreenshotIcon,
  UncheckedIcon,
  AtticFloorIcon,
  AtticSlopedRoofIcon,
  BasementIcon,
  CalculatorEuroIcon,
  CavityWallIcon,
  CloseBlackIcon,
  FlatRoofIcon,
  FloorIcon,
  InfoIcon,
  InfoIconBig,
  InnerWallIcon,
  OuterWallIcon,
  MouseIcon,
  MouseScrollIcon,
  RadioCheckedIcon,
  RadioUncheckedIcon,
  SloperRoofIcon,
  SwiperIcon,
  ModelIcon,
  ConfiguratorIcon,
  ClipboardIcon,
  FloppyDiskIcon,
};

const CalculatorIcon = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.400391 2.30962C0.400391 1.42675 1.11639 0.71167 2.00039 0.71167H14.0004C14.8844 0.71167 15.6004 1.42675 15.6004 2.30962V9.68451C15.0852 9.56706 14.5508 9.50037 14.0004 9.50037C12.0316 9.50037 10.248 10.292 8.94883 11.5711C8.72883 11.2859 8.38839 11.0983 8.00039 11.0983C7.33799 11.0983 6.80039 11.6352 6.80039 12.2968C6.80039 12.8153 7.13254 13.2533 7.59414 13.4203C7.32534 13.9445 7.11837 14.5043 6.98477 15.0932H4.00039C3.33799 15.0932 2.80039 15.6301 2.80039 16.2916C2.80039 16.9532 3.33799 17.4901 4.00039 17.4901H6.84727C6.94167 18.3442 7.1902 19.1504 7.5582 19.887H2.00039C1.11639 19.887 0.400391 19.1719 0.400391 18.2891V2.30962ZM13.2004 3.10859H2.80039V5.50551H13.2004V3.10859ZM5.20039 8.30191C5.20039 7.64036 4.66279 7.10345 4.00039 7.10345C3.33799 7.10345 2.80039 7.64036 2.80039 8.30191C2.80039 8.96346 3.33799 9.50037 4.00039 9.50037C4.66279 9.50037 5.20039 8.96346 5.20039 8.30191ZM9.20039 8.30191C9.20039 7.64036 8.66279 7.10345 8.00039 7.10345C7.33799 7.10345 6.80039 7.64036 6.80039 8.30191C6.80039 8.96346 7.33799 9.50037 8.00039 9.50037C8.66279 9.50037 9.20039 8.96346 9.20039 8.30191ZM13.2004 8.30191C13.2004 7.64036 12.6628 7.10345 12.0004 7.10345C11.338 7.10345 10.8004 7.64036 10.8004 8.30191C10.8004 8.96346 11.338 9.50037 12.0004 9.50037C12.6628 9.50037 13.2004 8.96346 13.2004 8.30191ZM5.20039 12.2968C5.20039 11.6352 4.66279 11.0983 4.00039 11.0983C3.33799 11.0983 2.80039 11.6352 2.80039 12.2968C2.80039 12.9583 3.33799 13.4952 4.00039 13.4952C4.66279 13.4952 5.20039 12.9583 5.20039 12.2968ZM8.40039 16.6911C8.40039 13.6023 10.9076 11.0983 14.0004 11.0983C17.0932 11.0983 19.6004 13.6023 19.6004 16.6911C19.6004 19.78 17.0932 22.2839 14.0004 22.2839C10.9076 22.2839 8.40039 19.78 8.40039 16.6911ZM15.584 13.5639C15.4052 13.5255 15.0993 13.4952 14.8059 13.4952C12.2019 13.4952 11.5871 15.12 11.4449 16.052H10.8004V16.6911H11.4039C11.4039 16.694 11.4037 16.6984 11.4035 16.7043C11.4014 16.7686 11.3934 17.0101 11.4391 17.3303H10.8004V17.9695H11.5938C11.9052 18.8605 12.7131 19.887 14.8059 19.887C15.1455 19.887 15.4132 19.8663 15.6004 19.8446V18.726C15.4264 18.7561 15.1333 18.7697 14.8105 18.7697C13.8541 18.7697 13.3296 18.399 13.041 17.9707H15.0004V17.3316H12.7645C12.6863 17.0154 12.6898 16.7578 12.6906 16.6972L12.6906 16.6924H15.0004V16.0532H12.7645C12.9169 15.4434 13.3851 14.615 14.8281 14.615C15.1467 14.615 15.3884 14.6274 15.584 14.6612V13.5639Z"
      fill="white"
    />
  </svg>
);

const SuccessIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 0C17.91 0 0 17.91 0 40C0 62.09 17.91 80 40 80C62.09 80 80 62.09 80 40C80 17.91 62.09 0 40 0ZM62.3567 32.3567L37.1567 57.5567C36.53 58.1833 35.6833 58.5333 34.8 58.5333C33.9167 58.5333 33.0667 58.1833 32.4433 57.5567L20.9333 46.0467C19.63 44.7433 19.63 42.6367 20.9333 41.3333C22.2367 40.03 24.3433 40.03 25.6467 41.3333L34.8 50.4867L57.6433 27.6433C58.9467 26.34 61.0533 26.34 62.3567 27.6433C63.66 28.9467 63.66 31.0533 62.3567 32.3567Z"
      fill="white"
    />
  </svg>
);

const CloseIcon = ({ onClick }: { onClick: () => void }) => (
  <svg
    style={{ cursor: "pointer" }}
    onClick={onClick}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0218 0.980362C17.4195 0.980854 17.808 1.09989 18.1378 1.32227C18.4675 1.54464 18.7234 1.86026 18.8729 2.22881C19.0224 2.59735 19.0586 3.00208 18.9769 3.39131C18.8952 3.78053 18.6994 4.13658 18.4144 4.41396L12.8284 9.99989L18.4144 15.5858C18.6063 15.7701 18.7596 15.9909 18.8651 16.2351C18.9707 16.4794 19.0265 16.7422 19.0292 17.0083C19.0319 17.2744 18.9815 17.5383 18.8809 17.7847C18.7803 18.0311 18.6316 18.2549 18.4435 18.443C18.2553 18.6312 18.0315 18.7799 17.7851 18.8805C17.5388 18.9811 17.2748 19.0315 17.0087 19.0288C16.7427 19.0261 16.4798 18.9703 16.2355 18.8647C15.9913 18.7591 15.7706 18.6059 15.5863 18.414L10.0003 12.828L4.41438 18.414C4.23009 18.6059 4.00936 18.7592 3.7651 18.8647C3.52084 18.9703 3.25797 19.0261 2.99189 19.0288C2.72581 19.0315 2.46186 18.9811 2.21551 18.8805C1.96915 18.7799 1.74534 18.6312 1.55718 18.443C1.36902 18.2549 1.2203 18.0311 1.11972 17.7847C1.01914 17.5384 0.968731 17.2744 0.971439 17.0083C0.974148 16.7422 1.02992 16.4794 1.13549 16.2351C1.24106 15.9909 1.39431 15.7701 1.58626 15.5858L7.1722 9.99989L1.58626 4.41396C1.29725 4.13303 1.09986 3.77135 1.01994 3.37631C0.940022 2.98127 0.981308 2.5713 1.13839 2.20013C1.29548 1.82896 1.56102 1.5139 1.90024 1.29624C2.23946 1.07858 2.63652 0.968481 3.03938 0.980362C3.55898 0.995844 4.05214 1.213 4.41438 1.58583L10.0003 7.17177L15.5863 1.58583C15.7729 1.39401 15.9961 1.24158 16.2427 1.13758C16.4892 1.03358 16.7542 0.980116 17.0218 0.980362Z"
      fill="white"
    />
  </svg>
);

const CommunicationIcon = () => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.39961 0.399902C4.53961 0.399902 0.599609 3.9815 0.599609 8.3999C0.599609 10.6692 1.64611 12.7101 3.3168 14.164C3.07716 14.9487 2.57729 15.7293 1.65898 16.4249C1.65846 16.4254 1.65794 16.4259 1.65742 16.4265C1.58168 16.4553 1.51647 16.5064 1.47043 16.5731C1.4244 16.6398 1.3997 16.7189 1.39961 16.7999C1.39961 16.906 1.44175 17.0077 1.51677 17.0827C1.59178 17.1578 1.69352 17.1999 1.79961 17.1999C1.82694 17.1996 1.85417 17.1964 1.88086 17.1905C3.43291 17.186 4.75716 16.523 5.81055 15.6921C6.31043 15.8954 6.83222 16.063 7.37617 16.1796C7.13297 15.4916 6.99961 14.7591 6.99961 13.9999C6.99961 12.8495 7.30816 11.7655 7.84336 10.7999H6.19961C5.75801 10.7999 5.39961 10.4415 5.39961 9.9999C5.39961 9.5583 5.75801 9.1999 6.19961 9.1999H9.0543C9.7039 8.5487 10.4792 8.0039 11.3512 7.5999H6.19961C5.75801 7.5999 5.39961 7.2415 5.39961 6.7999C5.39961 6.3583 5.75801 5.9999 6.19961 5.9999H12.5996C13.0412 5.9999 13.3996 6.3583 13.3996 6.7999C13.3996 6.8535 13.3795 6.90106 13.3699 6.95147C13.8963 6.85307 14.4412 6.7999 14.9996 6.7999C16.1052 6.7999 17.1592 7.00302 18.1184 7.37021C17.5616 3.43901 13.8748 0.399902 9.39961 0.399902ZM14.9996 8.3999C11.4652 8.3999 8.59961 10.9071 8.59961 13.9999C8.59961 17.0927 11.4652 19.5999 14.9996 19.5999C15.8445 19.5999 16.6487 19.4524 17.3871 19.1921C18.3682 19.8774 19.5555 20.3858 20.9152 20.3905C20.9429 20.3966 20.9712 20.3998 20.9996 20.3999C21.1057 20.3999 21.2074 20.3578 21.2825 20.2827C21.3575 20.2077 21.3996 20.106 21.3996 19.9999C21.3995 19.918 21.3742 19.8382 21.3273 19.7711C21.2804 19.7041 21.214 19.653 21.1371 19.6249C20.405 19.069 19.9357 18.4572 19.6543 17.8343C20.7333 16.8319 21.3996 15.4856 21.3996 13.9999C21.3996 10.9071 18.534 8.3999 14.9996 8.3999ZM12.5996 11.5999H17.3996C17.8412 11.5999 18.1996 11.9583 18.1996 12.3999C18.1996 12.8415 17.8412 13.1999 17.3996 13.1999H12.5996C12.158 13.1999 11.7996 12.8415 11.7996 12.3999C11.7996 11.9583 12.158 11.5999 12.5996 11.5999ZM12.5996 14.7999H17.3996C17.8412 14.7999 18.1996 15.1583 18.1996 15.5999C18.1996 16.0415 17.8412 16.3999 17.3996 16.3999H12.5996C12.158 16.3999 11.7996 16.0415 11.7996 15.5999C11.7996 15.1583 12.158 14.7999 12.5996 14.7999Z"
      fill="white"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.98777 0.389258C8.77587 0.39257 8.57394 0.479818 8.4263 0.631853C8.27866 0.783888 8.19737 0.988289 8.20027 1.2002V9.20019H5.80027C5.5881 9.20019 5.38461 9.28448 5.23458 9.43451C5.08456 9.58454 5.00027 9.78802 5.00027 10.0002C5.0004 10.1099 5.02308 10.2183 5.06689 10.3188C5.11071 10.4194 5.17472 10.5098 5.25496 10.5846L8.36433 13.6955C8.4391 13.7935 8.5355 13.8729 8.64601 13.9275C8.75653 13.9821 8.87817 14.0105 9.00144 14.0103C9.12471 14.0102 9.24628 13.9815 9.35666 13.9267C9.46704 13.8718 9.56324 13.7921 9.63777 13.6939L12.7456 10.5846L12.7471 10.583C12.8269 10.5083 12.8905 10.418 12.9341 10.3178C12.9776 10.2176 13.0001 10.1095 13.0003 10.0002C13.0003 9.78802 12.916 9.58454 12.766 9.43451C12.6159 9.28448 12.4124 9.20019 12.2003 9.20019H9.80027V1.2002C9.80173 1.09316 9.78171 0.986926 9.74138 0.887774C9.70104 0.788622 9.64122 0.698571 9.56546 0.622954C9.4897 0.547337 9.39953 0.487692 9.3003 0.44755C9.20107 0.407408 9.0948 0.387586 8.98777 0.389258ZM0.98777 8.38926C0.77587 8.39257 0.573941 8.47982 0.4263 8.63185C0.278659 8.78389 0.197369 8.98829 0.20027 9.20019V17.2002C0.20027 18.0746 0.92582 18.8002 1.80027 18.8002H16.2003C17.0747 18.8002 17.8003 18.0746 17.8003 17.2002V9.20019C17.8018 9.09418 17.7822 8.98894 17.7427 8.89056C17.7031 8.79219 17.6444 8.70265 17.57 8.62715C17.4956 8.55166 17.4069 8.49171 17.3091 8.45079C17.2113 8.40987 17.1063 8.3888 17.0003 8.3888C16.8942 8.3888 16.7893 8.40987 16.6915 8.45079C16.5937 8.49171 16.505 8.55166 16.4305 8.62715C16.3561 8.70265 16.2974 8.79219 16.2579 8.89056C16.2184 8.98894 16.1988 9.09418 16.2003 9.20019V17.2002H1.80027V9.20019C1.80174 9.09316 1.78171 8.98693 1.74138 8.88777C1.70104 8.78862 1.64123 8.69857 1.56546 8.62295C1.4897 8.54734 1.39953 8.48769 1.3003 8.44755C1.20107 8.40741 1.0948 8.38759 0.98777 8.38926Z"
      fill="white"
    />
  </svg>
);

const CaretUpIcon = ({ color }: { color: string }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7998 4.19992L9.7998 4.99992C9.7998 5.15432 9.7106 5.29512 9.571 5.36152C9.4314 5.42792 9.2662 5.40752 9.1462 5.30952L4.99981 1.91672L0.853005 5.30952C0.733405 5.40752 0.568205 5.42752 0.428205 5.36152C0.288205 5.29552 0.199805 5.15432 0.199805 4.99992L0.199805 4.19992C0.199805 4.07992 0.253805 3.96632 0.346605 3.89032L4.74661 0.290318C4.89421 0.169918 5.10581 0.169918 5.25341 0.290318L9.6534 3.89032C9.7458 3.96632 9.7998 4.07992 9.7998 4.19992Z"
      fill={color}
    />
  </svg>
);

const CaretDownIcon = ({ color }: { color: string }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.199951 1.29984L0.199951 0.499837C0.199951 0.345436 0.289151 0.204636 0.428751 0.138236C0.568351 0.0718363 0.733551 0.0922364 0.853551 0.190236L4.99995 3.58304L9.14675 0.190236C9.26635 0.0922364 9.43155 0.0722363 9.57155 0.138236C9.71155 0.204236 9.79995 0.345436 9.79995 0.499837V1.29984C9.79995 1.41984 9.74595 1.53344 9.65315 1.60944L5.25315 5.20944C5.10555 5.32984 4.89395 5.32984 4.74635 5.20944L0.346351 1.60944C0.253951 1.53344 0.199951 1.41984 0.199951 1.29984Z"
      fill={color}
    />
  </svg>
);

const CheckedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="3"
      fill="#E30612"
      stroke="#E30612"
      strokeWidth="2"
    />
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.96 7.07479C16.087 6.95031 16.1738 6.79058 16.2091 6.61622C16.2446 6.44066 16.2262 6.25846 16.1564 6.0935C16.0866 5.92855 15.9686 5.78853 15.8178 5.6918C15.6671 5.59506 15.4906 5.54613 15.3116 5.55141C15.0819 5.55825 14.8637 5.65376 14.703 5.8178L8.22226 12.2985L5.74231 9.8186C5.66115 9.73507 5.56436 9.66829 5.45743 9.62207C5.34887 9.57515 5.23205 9.55037 5.1138 9.54917C4.99554 9.54796 4.87824 9.57037 4.76876 9.61507C4.65927 9.65976 4.5598 9.72586 4.47618 9.80948C4.39256 9.8931 4.32647 9.99257 4.28177 10.1021C4.23707 10.2115 4.21466 10.3288 4.21587 10.4471C4.21707 10.5653 4.24186 10.6822 4.28877 10.7907C4.33499 10.8977 4.40177 10.9945 4.4853 11.0756L7.59375 14.1841C7.76045 14.3507 7.98656 14.4444 8.22226 14.4444C8.45795 14.4444 8.684 14.3508 8.8507 14.1841L15.96 7.07479Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="13.3333"
          height="13.3333"
          fill="white"
          transform="translate(3.33301 3.33337)"
        />
      </clipPath>
    </defs>
  </svg>
);

const ScreenshotIcon = ({ onClick }: { onClick: () => void }) => (
  <UnstyledButton onClick={onClick}>
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="5" fill="#2E3341" fillOpacity="0.75" />
      <path
        d="M10.8 9.2002C9.916 9.2002 9.2 9.9162 9.2 10.8002V11.6002C9.2 12.0418 9.5584 12.4002 10 12.4002C10.4416 12.4002 10.8 12.0418 10.8 11.6002V10.8002H11.6C12.0416 10.8002 12.4 10.4418 12.4 10.0002C12.4 9.5586 12.0416 9.2002 11.6 9.2002H10.8ZM14.8 9.2002C14.3584 9.2002 14 9.5586 14 10.0002C14 10.4426 14.3584 10.8002 14.8 10.8002H16.4C16.8416 10.8002 17.2 10.4418 17.2 10.0002C17.2 9.5586 16.8416 9.2002 16.4 9.2002H14.8ZM19.6 9.2002C19.1584 9.2002 18.8 9.5586 18.8 10.0002C18.8 10.4418 19.1584 10.8002 19.6 10.8002H21.2C21.6416 10.8002 22 10.4418 22 10.0002C22 9.5586 21.6416 9.2002 21.2 9.2002H19.6ZM24.4 9.2002C23.9584 9.2002 23.6 9.5586 23.6 10.0002C23.6 10.4418 23.9584 10.8002 24.4 10.8002H25.2V11.6002C25.2 12.0418 25.5584 12.4002 26 12.4002C26.4416 12.4002 26.8 12.0418 26.8 11.6002V10.8002C26.8 9.9162 26.084 9.2002 25.2 9.2002H24.4ZM10 14.0002C9.5584 14.0002 9.2 14.3586 9.2 14.8002V16.4002C9.2 16.8418 9.5584 17.2002 10 17.2002C10.4424 17.2002 10.8 16.8418 10.8 16.4002V14.8002C10.8 14.3586 10.4416 14.0002 10 14.0002ZM26 14.0002C25.5584 14.0002 25.2 14.3586 25.2 14.8002V16.4018C25.2 16.8434 25.5584 17.2018 26 17.2018C26.4416 17.2018 26.8 16.8434 26.8 16.4018V14.8002C26.8 14.3586 26.4416 14.0002 26 14.0002ZM18.4938 17.2002C18.1906 17.2002 17.9149 17.3712 17.7797 17.6424L17.6422 17.9158C17.371 18.4574 16.8165 18.8002 16.2109 18.8002H14.8C14.3584 18.8002 14 19.1586 14 19.6002V26.0002C14 26.4418 14.3584 26.8002 14.8 26.8002H26C26.4416 26.8002 26.8 26.4418 26.8 26.0002V19.6002C26.8 19.1586 26.4416 18.8002 26 18.8002H24.5891C23.9827 18.8002 23.429 18.4582 23.1578 17.9158L23.0203 17.6424C22.8851 17.372 22.6095 17.2002 22.3062 17.2002H18.4938ZM10 18.8002C9.5584 18.8002 9.2 19.1586 9.2 19.6002V21.2002C9.2 21.6418 9.5584 22.0002 10 22.0002C10.4416 22.0002 10.8 21.6418 10.8 21.2002V19.6002C10.8 19.1586 10.4416 18.8002 10 18.8002ZM20.4 19.6002C22.1672 19.6002 23.6 21.033 23.6 22.8002C23.6 24.5674 22.1672 26.0002 20.4 26.0002C18.6328 26.0002 17.2 24.5674 17.2 22.8002C17.2 21.033 18.6328 19.6002 20.4 19.6002ZM20.4 21.2002C19.9757 21.2002 19.5687 21.3688 19.2686 21.6688C18.9686 21.9689 18.8 22.3758 18.8 22.8002C18.8 23.2245 18.9686 23.6315 19.2686 23.9316C19.5687 24.2316 19.9757 24.4002 20.4 24.4002C20.8243 24.4002 21.2313 24.2316 21.5314 23.9316C21.8314 23.6315 22 23.2245 22 22.8002C22 22.3758 21.8314 21.9689 21.5314 21.6688C21.2313 21.3688 20.8243 21.2002 20.4 21.2002ZM10 23.6002C9.5584 23.6002 9.2 23.9586 9.2 24.4002V25.2002C9.2 26.0842 9.916 26.8002 10.8 26.8002H11.6C12.0416 26.8002 12.4 26.4418 12.4 26.0002C12.4 25.5586 12.0416 25.2002 11.6 25.2002H10.8V24.4002C10.8 23.9586 10.4416 23.6002 10 23.6002Z"
        fill="white"
      />
    </svg>
  </UnstyledButton>
);

const ScreenshotSavedCheckmark = () => (
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.10938 17.625C9.57812 18.0938 10.375 18.0938 10.8438 17.625L24.625 3.84375C25.0938 3.375 25.0938 2.57812 24.625 2.10938L22.9375 0.421875C22.4688 -0.046875 21.7188 -0.046875 21.25 0.421875L10 11.6719L4.70312 6.42188C4.23438 5.95312 3.48438 5.95312 3.01562 6.42188L1.32812 8.10938C0.859375 8.57812 0.859375 9.375 1.32812 9.84375L9.10938 17.625Z"
      fill="#454545"
    />
  </svg>
);

const ResetIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9998 0.799805C4.03052 0.799805 0.799805 4.03052 0.799805 7.9998C0.799805 11.9691 4.03052 15.1998 7.9998 15.1998C11.9691 15.1998 15.1998 11.9691 15.1998 7.9998C15.2009 7.9203 15.1862 7.84136 15.1566 7.76758C15.1269 7.6938 15.0829 7.62665 15.0271 7.57002C14.9713 7.5134 14.9048 7.46844 14.8314 7.43775C14.758 7.40706 14.6793 7.39126 14.5998 7.39126C14.5203 7.39126 14.4416 7.40706 14.3682 7.43775C14.2949 7.46844 14.2283 7.5134 14.1725 7.57002C14.1167 7.62665 14.0727 7.6938 14.043 7.76758C14.0134 7.84136 13.9987 7.9203 13.9998 7.9998C13.9998 11.3205 11.3205 13.9998 7.9998 13.9998C4.67908 13.9998 1.9998 11.3205 1.9998 7.9998C1.9998 4.67908 4.67908 1.9998 7.9998 1.9998C9.50699 1.9998 10.8741 2.55842 11.9268 3.47285L10.3998 4.9998H13.9998V1.3998L12.7764 2.62324C11.5041 1.49303 9.83212 0.799805 7.9998 0.799805Z"
      fill="#6E7188"
    />
  </svg>
);

const RotateScreenIcon = () => (
  <svg
    width="73"
    height="73"
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.375 66C30.375 69.315 33.06 72 36.375 72H66.375C69.69 72 72.375 69.315 72.375 66V5.99999C72.375 2.68499 69.69 -7.62939e-06 66.375 -7.62939e-06H36.375C33.06 -7.62939e-06 30.375 2.68499 30.375 5.99999L30.375 66ZM36.3752 65.9999L36.3752 5.99993H66.3752V65.9999H60.3752L59.133 64.7578C58.008 63.6328 56.4808 62.9999 54.8908 62.9999H47.8654C46.2754 62.9999 44.7541 63.6299 43.6291 64.7519L42.3752 65.9999H36.3752Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 30.375C2.685 30.375 0 33.06 0 36.375V66.375C0 69.69 2.685 72.375 6 72.375H66C69.315 72.375 72 69.69 72 66.375V36.375C72 33.06 69.315 30.375 66 30.375H6ZM6.00018 36.3751H66.0002V66.3751H6.00018V60.3751L7.24237 59.1329C8.36737 58.0079 9.00018 56.4807 9.00018 54.8907V47.8653C9.00018 46.2753 8.37023 44.754 7.24823 43.629L6.00018 42.3751V36.3751Z"
      fill="white"
    />
    <path
      d="M25.8753 4.16397C22.2531 4.10976 18.5911 5.23967 15.5162 7.63483C11.8561 10.4859 9.76347 14.5857 9.29958 18.8682L5.78271 18.8959L11.3654 27.1476L16.266 18.8198L12.9843 18.8461C13.4356 15.6686 15.0443 12.6537 17.7711 10.5297C20.1761 8.65635 23.0427 7.7771 25.8753 7.82856V4.16397Z"
      fill="white"
    />
  </svg>
);

const ScreenDimensionsIcon = () => (
  <svg
    width="100"
    height="75"
    viewBox="0 0 100 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M91.5 10C91.5 9.17157 90.8284 8.5 90 8.5H76.5C75.6716 8.5 75 9.17157 75 10C75 10.8284 75.6716 11.5 76.5 11.5L88.5 11.5L88.5 23.5C88.5 24.3284 89.1716 25 90 25C90.8284 25 91.5 24.3284 91.5 23.5V10ZM69.0607 33.0607L91.0607 11.0607L88.9393 8.93934L66.9393 30.9393L69.0607 33.0607Z"
      fill="white"
    />
    <path
      d="M8.5 65C8.5 65.8284 9.17157 66.5 10 66.5H23.5C24.3284 66.5 25 65.8284 25 65C25 64.1716 24.3284 63.5 23.5 63.5L11.5 63.5L11.5 51.5C11.5 50.6716 10.8284 50 10 50C9.17157 50 8.5 50.6716 8.5 51.5V65ZM30.9393 41.9393L8.93934 63.9393L11.0607 66.0607L33.0607 44.0607L30.9393 41.9393Z"
      fill="white"
    />
    <rect
      x="2"
      y="2"
      width="96"
      height="71"
      rx="3"
      stroke="white"
      strokeWidth="4"
    />
  </svg>
);

const EyeClosedIcon = ({ hidden }: { hidden?: boolean }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {!hidden && <>
      <path
        d="M0 0H16C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32H0V0Z"
        fill="#F8F8F9"
      />
      <path
        d="M16.0007 11.7998C12.1244 11.7998 9.61916 15.6306 9.56763 15.71C9.56709 15.7108 9.5576 15.7236 9.5576 15.7236C9.49858 15.8036 9.46665 15.9004 9.46646 15.9998C9.46654 16.0901 9.49282 16.1784 9.54211 16.2541C9.5439 16.2572 9.54572 16.2602 9.54758 16.2632C9.55719 16.2811 9.82074 16.7454 10.3159 17.3469L9.61776 17.9895C9.57232 18.0309 9.5355 18.0809 9.50942 18.1365C9.48335 18.1922 9.46852 18.2524 9.46579 18.3139C9.46307 18.3753 9.4725 18.4366 9.49354 18.4943C9.51458 18.5521 9.54683 18.6051 9.58842 18.6504C9.63002 18.6956 9.68014 18.7322 9.73591 18.7581C9.79169 18.7839 9.85201 18.7984 9.91343 18.8009C9.97485 18.8033 10.0361 18.7936 10.0938 18.7723C10.1515 18.751 10.2043 18.7186 10.2494 18.6768L10.9448 18.0369C11.1747 18.2627 11.4331 18.4891 11.7205 18.7096L11.2465 19.4515C11.2121 19.5031 11.1883 19.5611 11.1766 19.6221C11.1648 19.683 11.1653 19.7457 11.1781 19.8065C11.1909 19.8672 11.2156 19.9248 11.2509 19.9758C11.2862 20.0269 11.3314 20.0704 11.3837 20.1038C11.436 20.1372 11.4944 20.1598 11.5556 20.1704C11.6168 20.1809 11.6794 20.1791 11.7399 20.1652C11.8004 20.1512 11.8575 20.1253 11.9078 20.089C11.9582 20.0527 12.0008 20.0067 12.0331 19.9537L12.4934 19.2337C12.804 19.4169 13.1428 19.5802 13.5033 19.7222L13.2262 20.5124C13.206 20.5703 13.1974 20.6316 13.2008 20.6928C13.2043 20.754 13.2198 20.8139 13.2464 20.8692C13.273 20.9244 13.3102 20.9738 13.356 21.0147C13.4017 21.0555 13.455 21.0869 13.5129 21.1072C13.5707 21.1274 13.632 21.136 13.6932 21.1326C13.7545 21.1291 13.8144 21.1136 13.8696 21.087C13.9248 21.0604 13.9743 21.0232 14.0151 20.9774C14.0559 20.9317 14.0874 20.8784 14.1076 20.8205L14.392 20.0075C14.7507 20.094 15.1337 20.1466 15.5331 20.1734V21.1331C15.5323 21.195 15.5437 21.2564 15.5667 21.3138C15.5898 21.3711 15.624 21.4234 15.6674 21.4674C15.7109 21.5115 15.7626 21.5464 15.8197 21.5703C15.8767 21.5942 15.9379 21.6065 15.9998 21.6065C16.0616 21.6065 16.1229 21.5942 16.1799 21.5703C16.237 21.5464 16.2887 21.5115 16.3321 21.4674C16.3756 21.4234 16.4098 21.3711 16.4328 21.3138C16.4559 21.2564 16.4673 21.195 16.4665 21.1331V20.1734C16.8664 20.1466 17.2494 20.0941 17.6085 20.0075L17.8929 20.8205C17.9114 20.8804 17.9419 20.936 17.9824 20.9839C18.0229 21.0318 18.0726 21.071 18.1286 21.0992C18.1846 21.1275 18.2457 21.1441 18.3083 21.1482C18.3709 21.1523 18.4337 21.1437 18.4929 21.123C18.5521 21.1023 18.6065 21.0699 18.6529 21.0277C18.6993 20.9854 18.7367 20.9343 18.7628 20.8773C18.789 20.8203 18.8034 20.7586 18.8052 20.6959C18.8071 20.6333 18.7962 20.5708 18.7734 20.5124L18.4972 19.7222C18.8577 19.5802 19.1965 19.4169 19.5071 19.2337L19.9674 19.9537C19.9997 20.0067 20.0423 20.0527 20.0927 20.089C20.143 20.1253 20.2001 20.1512 20.2606 20.1652C20.321 20.1791 20.3837 20.1809 20.4449 20.1704C20.506 20.1598 20.5645 20.1372 20.6168 20.1038C20.6691 20.0704 20.7143 20.0269 20.7496 19.9758C20.7849 19.9248 20.8096 19.8672 20.8224 19.8065C20.8352 19.7457 20.8357 19.683 20.8239 19.6221C20.8122 19.5611 20.7884 19.5031 20.754 19.4515L20.28 18.7096C20.5674 18.4891 20.8258 18.2627 21.0556 18.0369L21.7502 18.6768C21.7953 18.7183 21.8482 18.7506 21.9058 18.7717C21.9633 18.7928 22.0245 18.8024 22.0858 18.7998C22.1471 18.7973 22.2073 18.7827 22.2629 18.7569C22.3186 18.7311 22.3686 18.6946 22.4102 18.6495C22.4517 18.6044 22.4839 18.5515 22.5051 18.4939C22.5262 18.4363 22.5357 18.3751 22.5332 18.3138C22.5306 18.2525 22.516 18.1924 22.4902 18.1367C22.4644 18.0811 22.4279 18.031 22.3827 17.9895L21.6846 17.3469C22.1858 16.738 22.4521 16.2647 22.4557 16.2577C22.4557 16.2577 22.4575 16.2541 22.4575 16.2541C22.5068 16.1784 22.533 16.0901 22.5331 15.9998C22.533 15.9008 22.5014 15.8044 22.4429 15.7245C22.4429 15.7242 22.4429 15.7239 22.4429 15.7236C22.4429 15.7236 19.9174 11.7998 16.0007 11.7998Z"
        fill="#6E7188"
      />
    </>
    }
  </svg>
);

const EyeOpenIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0H16C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32H0V0Z"
      fill="#2E3341"
    />
    <path
      d="M0 0H16C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32H0V0Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M16 11.3335C11.8381 11.3335 9.14979 15.632 9.10117 15.7103C9.03572 15.7928 9.00007 15.8949 9 16.0002C9.00008 16.0905 9.02636 16.1788 9.07565 16.2545C9.07626 16.2554 9.07686 16.2563 9.07747 16.2572C9.0855 16.2738 11.3421 20.6668 16 20.6668C20.6381 20.6668 22.8914 16.3169 22.9189 16.2636C22.9207 16.2606 22.9226 16.2575 22.9243 16.2545C22.9736 16.1788 22.9999 16.0905 23 16.0002C23 15.8953 22.9647 15.7935 22.8997 15.7112C22.8994 15.7109 22.8991 15.7106 22.8988 15.7103C22.8502 15.632 20.1619 11.3335 16 11.3335ZM16 12.7335C17.8041 12.7335 19.2667 14.196 19.2667 16.0002C19.2667 17.8043 17.8041 19.2668 16 19.2668C14.1959 19.2668 12.7333 17.8043 12.7333 16.0002C12.7333 14.196 14.1959 12.7335 16 12.7335ZM16 14.6002C15.6287 14.6002 15.2726 14.7477 15.0101 15.0102C14.7475 15.2728 14.6 15.6289 14.6 16.0002C14.6 16.3715 14.7475 16.7276 15.0101 16.9901C15.2726 17.2527 15.6287 17.4002 16 17.4002C16.3713 17.4002 16.7274 17.2527 16.9899 16.9901C17.2525 16.7276 17.4 16.3715 17.4 16.0002C17.4 15.6289 17.2525 15.2728 16.9899 15.0102C16.7274 14.7477 16.3713 14.6002 16 14.6002Z"
      fill="white"
    />
  </svg>
);

const HomeIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect opacity="0.75" width="36" height="36" rx="5" fill="#2E3341" />
    <g>
      <path
        d="M18 8.3999C17.7988 8.40053 17.6052 8.47696 17.4578 8.61396C17.452 8.61857 17.4463 8.62326 17.4406 8.62803L8.71409 15.7655C8.70401 15.7731 8.69411 15.7809 8.6844 15.789L8.65471 15.814V15.8155C8.57447 15.8903 8.51046 15.9807 8.46665 16.0813C8.42284 16.1818 8.40016 16.2902 8.40002 16.3999C8.40002 16.6121 8.48431 16.8156 8.63434 16.9656C8.78437 17.1156 8.98785 17.1999 9.20002 17.1999H10V25.9999C10 26.8839 10.716 27.5999 11.6 27.5999L24.4 27.5999C25.284 27.5999 26 26.8839 26 25.9999L26 17.1999H26.8C27.0122 17.1999 27.2157 17.1156 27.3657 16.9656C27.5157 16.8156 27.6 16.6121 27.6 16.3999C27.5999 16.2902 27.5772 16.1818 27.5334 16.0813C27.4896 15.9807 27.4256 15.8903 27.3453 15.8155V15.814L27.3328 15.8046C27.3153 15.7887 27.297 15.7736 27.2781 15.7593L26 14.714V11.5999C26 11.1583 25.6416 10.7999 25.2 10.7999H24.4C23.9584 10.7999 23.6 11.1583 23.6 11.5999V12.7515L18.5531 8.62334L18.5422 8.61396C18.3948 8.47696 18.2012 8.40053 18 8.3999Z"
        fill="white"
      />
    </g>
  </svg>
);

const AtticFloorIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 26.02C27.5523 26.02 28 25.5723 28 25.02C28 24.4677 27.5523 24.02 27 24.02C26.4477 24.02 26 24.4677 26 25.02C26 25.5723 26.4477 26.02 27 26.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z"
      fill="#D4D4DB"
    />
    <path
      d="M28 11.02H2C1.73478 11.02 1.48043 11.1254 1.29289 11.3129C1.10536 11.5004 1 11.7548 1 12.02C1 12.2852 1.10536 12.5396 1.29289 12.7271C1.48043 12.9147 1.73478 13.02 2 13.02H28C28.2652 13.02 28.5196 12.9147 28.7071 12.7271C28.8946 12.5396 29 12.2852 29 12.02C29 11.7548 28.8946 11.5004 28.7071 11.3129C28.5196 11.1254 28.2652 11.02 28 11.02Z"
      fill={lineColor}
    />
  </svg>
);

const AtticSlopedRoofIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.09 26.36C27.6423 26.36 28.09 25.9123 28.09 25.36C28.09 24.8077 27.6423 24.36 27.09 24.36C26.5377 24.36 26.09 24.8077 26.09 25.36C26.09 25.9123 26.5377 26.36 27.09 26.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 22.36C27.6423 22.36 28.09 21.9123 28.09 21.36C28.09 20.8077 27.6423 20.36 27.09 20.36C26.5377 20.36 26.09 20.8077 26.09 21.36C26.09 21.9123 26.5377 22.36 27.09 22.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 18.36C27.6423 18.36 28.09 17.9123 28.09 17.36C28.09 16.8077 27.6423 16.36 27.09 16.36C26.5377 16.36 26.09 16.8077 26.09 17.36C26.09 17.9123 26.5377 18.36 27.09 18.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 14.36C27.6423 14.36 28.09 13.9123 28.09 13.36C28.09 12.8077 27.6423 12.36 27.09 12.36C26.5377 12.36 26.09 12.8077 26.09 13.36C26.09 13.9123 26.5377 14.36 27.09 14.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 24.36C2.89222 24.36 2.69888 24.4186 2.53443 24.5285C2.36998 24.6384 2.2418 24.7946 2.16612 24.9773C2.09043 25.16 2.07063 25.3611 2.10921 25.5551C2.1478 25.7491 2.24304 25.9272 2.38289 26.0671C2.52274 26.2069 2.70093 26.3022 2.89491 26.3408C3.08889 26.3794 3.28995 26.3596 3.47268 26.2839C3.65541 26.2082 3.81158 26.08 3.92147 25.9156C4.03135 25.7511 4.09 25.5578 4.09 25.36C4.09 25.0948 3.98464 24.8404 3.7971 24.6529C3.60957 24.4653 3.35521 24.36 3.09 24.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 22.36C3.64228 22.36 4.09 21.9123 4.09 21.36C4.09 20.8077 3.64228 20.36 3.09 20.36C2.53771 20.36 2.09 20.8077 2.09 21.36C2.09 21.9123 2.53771 22.36 3.09 22.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 18.36C3.64228 18.36 4.09 17.9123 4.09 17.36C4.09 16.8077 3.64228 16.36 3.09 16.36C2.53771 16.36 2.09 16.8077 2.09 17.36C2.09 17.9123 2.53771 18.36 3.09 18.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 14.36C3.64228 14.36 4.09 13.9123 4.09 13.36C4.09 12.8077 3.64228 12.36 3.09 12.36C2.53771 12.36 2.09 12.8077 2.09 13.36C2.09 13.9123 2.53771 14.36 3.09 14.36Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.9997 13.02C28.2188 13.0199 28.4318 12.9479 28.606 12.815C28.7802 12.6821 28.9059 12.4957 28.9638 12.2844C29.0217 12.0731 29.0087 11.8487 28.9267 11.6455C28.8446 11.4424 28.6981 11.2718 28.5097 11.16L15.5797 2.2C15.4066 2.07018 15.1961 2 14.9797 2C14.7633 2 14.5528 2.07018 14.3797 2.2L8.99971 5.96V5.02C8.99971 4.75478 8.89435 4.50043 8.70681 4.31289C8.51928 4.12536 8.26492 4.02 7.99971 4.02H6.99971C6.73449 4.02 6.48014 4.12536 6.2926 4.31289C6.10506 4.50043 5.99971 4.75478 5.99971 5.02V8.02L1.48971 11.16C1.30129 11.2718 1.1548 11.4424 1.07276 11.6455C0.99072 11.8487 0.977662 12.0731 1.0356 12.2844C1.09353 12.4957 1.21925 12.6821 1.39343 12.815C1.56761 12.9479 1.78062 13.0199 1.99971 13.02H27.9997Z"
      fill="#D4D4DB"
    />
    <mask
      id="mask0"
      //@ts-ignore
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="28"
      height="12"
    >
      <path
        d="M27.9997 13.02C28.2188 13.0199 28.4318 12.9479 28.606 12.815C28.7802 12.6821 28.9059 12.4957 28.9638 12.2844C29.0217 12.0731 29.0087 11.8487 28.9267 11.6455C28.8446 11.4424 28.6981 11.2718 28.5097 11.16L15.5797 2.2C15.4066 2.07018 15.1961 2 14.9797 2C14.7633 2 14.5528 2.07018 14.3797 2.2L8.99971 5.96V5.02C8.99971 4.75478 8.89435 4.50043 8.70681 4.31289C8.51928 4.12536 8.26492 4.02 7.99971 4.02H6.99971C6.73449 4.02 6.48014 4.12536 6.2926 4.31289C6.10506 4.50043 5.99971 4.75478 5.99971 5.02V8.02L1.48971 11.16C1.30129 11.2718 1.1548 11.4424 1.07276 11.6455C0.99072 11.8487 0.977662 12.0731 1.0356 12.2844C1.09353 12.4957 1.21925 12.6821 1.39343 12.815C1.56761 12.9479 1.78062 13.0199 1.99971 13.02H27.9997Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M22.7781 -1.18187L1.41813 13.6481C1.30799 13.7209 1.18453 13.7711 1.05488 13.7959C0.925227 13.8207 0.791947 13.8196 0.662726 13.7927C0.533505 13.7657 0.4109 13.7134 0.301983 13.6388C0.193067 13.5643 0.0999931 13.4689 0.0281313 13.3581C-0.122686 13.1405 -0.181062 12.872 -0.134198 12.6114C-0.087333 12.3509 0.0609479 12.1195 0.278131 11.9681L21.6381 -2.82187C21.8557 -2.97269 22.1242 -3.03107 22.3848 -2.9842C22.6454 -2.93734 22.8767 -2.78906 23.0281 -2.57187C23.1789 -2.35428 23.2373 -2.08576 23.1905 -1.8252C23.1436 -1.56463 22.9953 -1.33328 22.7781 -1.18187Z"
        fill={lineColor}
      />
    </g>
  </svg>
);

const BasementIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 25.02C27.5523 25.02 28 24.5723 28 24.02C28 23.4677 27.5523 23.02 27 23.02C26.4477 23.02 26 23.4677 26 24.02C26 24.5723 26.4477 25.02 27 25.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 21.02C27.5523 21.02 28 20.5723 28 20.02C28 19.4677 27.5523 19.02 27 19.02C26.4477 19.02 26 19.4677 26 20.02C26 20.5723 26.4477 21.02 27 21.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 17.02C27.5523 17.02 28 16.5723 28 16.02C28 15.4677 27.5523 15.02 27 15.02C26.4477 15.02 26 15.4677 26 16.02C26 16.5723 26.4477 17.02 27 17.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 13.02C27.5523 13.02 28 12.5723 28 12.02C28 11.4677 27.5523 11.02 27 11.02C26.4477 11.02 26 11.4677 26 12.02C26 12.5723 26.4477 13.02 27 13.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 29.02C27.5523 29.02 28 28.5723 28 28.02C28 27.4677 27.5523 27.02 27 27.02C26.4477 27.02 26 27.4677 26 28.02C26 28.5723 26.4477 29.02 27 29.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 23.02C2.80222 23.02 2.60888 23.0787 2.44443 23.1885C2.27998 23.2984 2.15181 23.4546 2.07612 23.6373C2.00043 23.8201 1.98063 24.0211 2.01922 24.2151C2.0578 24.4091 2.15304 24.5873 2.29289 24.7271C2.43275 24.867 2.61093 24.9622 2.80491 25.0008C2.99889 25.0394 3.19996 25.0196 3.38268 24.9439C3.56541 24.8682 3.72159 24.74 3.83147 24.5756C3.94135 24.4111 4 24.2178 4 24.02C4 23.7548 3.89464 23.5004 3.70711 23.3129C3.51957 23.1254 3.26522 23.02 3 23.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 21.02C3.55228 21.02 4 20.5723 4 20.02C4 19.4677 3.55228 19.02 3 19.02C2.44772 19.02 2 19.4677 2 20.02C2 20.5723 2.44772 21.02 3 21.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 17.02C3.55228 17.02 4 16.5723 4 16.02C4 15.4677 3.55228 15.02 3 15.02C2.44772 15.02 2 15.4677 2 16.02C2 16.5723 2.44772 17.02 3 17.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 13.02C3.55228 13.02 4 12.5723 4 12.02C4 11.4677 3.55228 11.02 3 11.02C2.44772 11.02 2 11.4677 2 12.02C2 12.5723 2.44772 13.02 3 13.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 29.02C3.55228 29.02 4 28.5723 4 28.02C4 27.4677 3.55228 27.02 3 27.02C2.44772 27.02 2 27.4677 2 28.02C2 28.5723 2.44772 29.02 3 29.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M28 12.02C28.2191 12.0199 28.4321 11.9479 28.6063 11.815C28.7805 11.6821 28.9062 11.4957 28.9641 11.2844C29.0221 11.0731 29.009 10.8487 28.927 10.6455C28.8449 10.4424 28.6984 10.2718 28.51 10.16L15.58 1.2C15.4069 1.07018 15.1964 1 14.98 1C14.7636 1 14.5531 1.07018 14.38 1.2L9.00001 4.96V4.02C9.00001 3.75478 8.89465 3.50043 8.70712 3.31289C8.51958 3.12536 8.26523 3.02 8.00001 3.02H7.00001C6.7348 3.02 6.48044 3.12536 6.2929 3.31289C6.10537 3.50043 6.00001 3.75478 6.00001 4.02V7.02L1.49001 10.16C1.3016 10.2718 1.15511 10.4424 1.07307 10.6455C0.991025 10.8487 0.977967 11.0731 1.0359 11.2844C1.09384 11.4957 1.21956 11.6821 1.39374 11.815C1.56792 11.9479 1.78092 12.0199 2.00001 12.02H28Z"
      fill="#D4D4DB"
    />
    <path
      d="M6.96002 24.98C7.51231 24.98 7.96002 24.5323 7.96002 23.98C7.96002 23.4277 7.51231 22.98 6.96002 22.98C6.40774 22.98 5.96002 23.4277 5.96002 23.98C5.96002 24.5323 6.40774 24.98 6.96002 24.98Z"
      fill="#D4D4DB"
    />
    <path
      d="M10.96 24.98C11.5123 24.98 11.96 24.5323 11.96 23.98C11.96 23.4277 11.5123 22.98 10.96 22.98C10.4077 22.98 9.96002 23.4277 9.96002 23.98C9.96002 24.5323 10.4077 24.98 10.96 24.98Z"
      fill="#D4D4DB"
    />
    <path
      d="M14.96 24.98C15.5123 24.98 15.96 24.5323 15.96 23.98C15.96 23.4277 15.5123 22.98 14.96 22.98C14.4077 22.98 13.96 23.4277 13.96 23.98C13.96 24.5323 14.4077 24.98 14.96 24.98Z"
      fill="#D4D4DB"
    />
    <path
      d="M19.01 24.98C19.5623 24.98 20.01 24.5323 20.01 23.98C20.01 23.4277 19.5623 22.98 19.01 22.98C18.4577 22.98 18.01 23.4277 18.01 23.98C18.01 24.5323 18.4577 24.98 19.01 24.98Z"
      fill="#D4D4DB"
    />
    <path
      d="M23.01 24.98C23.5623 24.98 24.01 24.5323 24.01 23.98C24.01 23.4277 23.5623 22.98 23.01 22.98C22.4577 22.98 22.01 23.4277 22.01 23.98C22.01 24.5323 22.4577 24.98 23.01 24.98Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 27.02H3C2.73478 27.02 2.48043 27.1254 2.29289 27.3129C2.10536 27.5004 2 27.7548 2 28.02C2 28.2852 2.10536 28.5396 2.29289 28.7271C2.48043 28.9147 2.73478 29.02 3 29.02H27C27.2652 29.02 27.5196 28.9147 27.7071 28.7271C27.8946 28.5396 28 28.2852 28 28.02C28 27.7548 27.8946 27.5004 27.7071 27.3129C27.5196 27.1254 27.2652 27.02 27 27.02Z"
      fill={lineColor}
    />
  </svg>
);

const CalculatorEuroIcon = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.399902 2.3998C0.399902 1.5158 1.1159 0.799805 1.9999 0.799805H13.9999C14.8839 0.799805 15.5999 1.5158 15.5999 2.3998V9.78418C15.0847 9.66658 14.5503 9.5998 13.9999 9.5998C12.0311 9.5998 10.2475 10.3924 8.94834 11.6732C8.72834 11.3876 8.3879 11.1998 7.9999 11.1998C7.3375 11.1998 6.7999 11.7374 6.7999 12.3998C6.7999 12.919 7.13205 13.3576 7.59365 13.5248C7.32485 14.0496 7.11788 14.6102 6.98428 15.1998H3.9999C3.3375 15.1998 2.7999 15.7374 2.7999 16.3998C2.7999 17.0622 3.3375 17.5998 3.9999 17.5998H6.84678C6.94118 18.455 7.18971 19.2622 7.55771 19.9998H1.9999C1.1159 19.9998 0.399902 19.2838 0.399902 18.3998V2.3998ZM13.1999 3.1998H2.7999V5.5998H13.1999V3.1998ZM5.1999 8.3998C5.1999 7.7374 4.6623 7.1998 3.9999 7.1998C3.3375 7.1998 2.7999 7.7374 2.7999 8.3998C2.7999 9.0622 3.3375 9.5998 3.9999 9.5998C4.6623 9.5998 5.1999 9.0622 5.1999 8.3998ZM9.1999 8.3998C9.1999 7.7374 8.6623 7.1998 7.9999 7.1998C7.3375 7.1998 6.7999 7.7374 6.7999 8.3998C6.7999 9.0622 7.3375 9.5998 7.9999 9.5998C8.6623 9.5998 9.1999 9.0622 9.1999 8.3998ZM13.1999 8.3998C13.1999 7.7374 12.6623 7.1998 11.9999 7.1998C11.3375 7.1998 10.7999 7.7374 10.7999 8.3998C10.7999 9.0622 11.3375 9.5998 11.9999 9.5998C12.6623 9.5998 13.1999 9.0622 13.1999 8.3998ZM5.1999 12.3998C5.1999 11.7374 4.6623 11.1998 3.9999 11.1998C3.3375 11.1998 2.7999 11.7374 2.7999 12.3998C2.7999 13.0622 3.3375 13.5998 3.9999 13.5998C4.6623 13.5998 5.1999 13.0622 5.1999 12.3998ZM8.3999 16.7998C8.3999 13.707 10.9071 11.1998 13.9999 11.1998C17.0927 11.1998 19.5999 13.707 19.5999 16.7998C19.5999 19.8926 17.0927 22.3998 13.9999 22.3998C10.9071 22.3998 8.3999 19.8926 8.3999 16.7998ZM15.5835 13.6686C15.4047 13.6302 15.0988 13.5998 14.8054 13.5998C12.2014 13.5998 11.5866 15.2267 11.4444 16.1598H10.7999V16.7998H11.4034C11.4034 16.8027 11.4032 16.8071 11.403 16.813C11.4009 16.8774 11.393 17.1191 11.4386 17.4398H10.7999V18.0798H11.5933C11.9047 18.972 12.7126 19.9998 14.8054 19.9998C15.145 19.9998 15.4127 19.9791 15.5999 19.9573V18.8373C15.4259 18.8674 15.1329 18.8811 14.8101 18.8811C13.8537 18.8811 13.3291 18.5099 13.0405 18.0811H14.9999V17.4411H12.764C12.6858 17.1245 12.6893 16.8666 12.6901 16.8059L12.6901 16.8011H14.9999V16.1611H12.764C12.9164 15.5505 13.3846 14.7211 14.8276 14.7211C15.1462 14.7211 15.3879 14.7334 15.5835 14.7673V13.6686Z"
      fill="#E30612"
    />
  </svg>
);

const CavityWallIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 24.02C26.8022 24.02 26.6089 24.0787 26.4444 24.1885C26.28 24.2984 26.1518 24.4546 26.0761 24.6373C26.0004 24.8201 25.9806 25.0211 26.0192 25.2151C26.0578 25.4091 26.153 25.5873 26.2929 25.7271C26.4327 25.867 26.6109 25.9622 26.8049 26.0008C26.9989 26.0394 27.2 26.0196 27.3827 25.9439C27.5654 25.8682 27.7216 25.74 27.8315 25.5756C27.9414 25.4111 28 25.2178 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 26.02V13.02C27 12.7548 26.8946 12.5004 26.7071 12.3129C26.5196 12.1254 26.2652 12.02 26 12.02C25.7348 12.02 25.4804 12.1254 25.2929 12.3129C25.1054 12.5004 25 12.7548 25 13.02V25.02C25 25.2852 25.1054 25.5396 25.2929 25.7271C25.4804 25.9147 25.7348 26.02 26 26.02H27Z"
      fill={lineColor}
    />
    <path
      d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z"
      fill="#D4D4DB"
    />
  </svg>
);

const CloseBlackIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0216 0.980362C17.4193 0.980854 17.8078 1.09989 18.1375 1.32227C18.4672 1.54464 18.7232 1.86026 18.8726 2.22881C19.0221 2.59735 19.0583 3.00208 18.9767 3.39131C18.895 3.78053 18.6991 4.13658 18.4141 4.41396L12.8282 9.99989L18.4141 15.5858C18.6061 15.7701 18.7593 15.9909 18.8649 16.2351C18.9705 16.4794 19.0262 16.7422 19.0289 17.0083C19.0317 17.2744 18.9812 17.5383 18.8807 17.7847C18.7801 18.0311 18.6314 18.2549 18.4432 18.443C18.255 18.6312 18.0312 18.7799 17.7849 18.8805C17.5385 18.9811 17.2746 19.0315 17.0085 19.0288C16.7424 19.0261 16.4796 18.9703 16.2353 18.8647C15.991 18.7591 15.7703 18.6059 15.586 18.414L10.0001 12.828L4.41414 18.414C4.22985 18.6059 4.00911 18.7592 3.76485 18.8647C3.5206 18.9703 3.25773 19.0261 2.99165 19.0288C2.72556 19.0315 2.46162 18.9811 2.21526 18.8805C1.96891 18.7799 1.74509 18.6312 1.55694 18.443C1.36878 18.2549 1.22005 18.0311 1.11948 17.7847C1.0189 17.5384 0.968487 17.2744 0.971195 17.0083C0.973904 16.7422 1.02968 16.4794 1.13525 16.2351C1.24082 15.9909 1.39407 15.7701 1.58602 15.5858L7.17195 9.99989L1.58602 4.41396C1.29701 4.13303 1.09961 3.77135 1.0197 3.37631C0.939777 2.98127 0.981064 2.5713 1.13815 2.20013C1.29523 1.82896 1.56078 1.5139 1.9 1.29624C2.23921 1.07858 2.63627 0.968481 3.03914 0.980362C3.55874 0.995844 4.0519 1.213 4.41414 1.58583L10.0001 7.17177L15.586 1.58583C15.7726 1.39401 15.9958 1.24158 16.2424 1.13758C16.489 1.03358 16.7539 0.980116 17.0216 0.980362Z"
      fill="#2E3341"
    />
    <path
      d="M17.0216 0.980362C17.4193 0.980854 17.8078 1.09989 18.1375 1.32227C18.4672 1.54464 18.7232 1.86026 18.8726 2.22881C19.0221 2.59735 19.0583 3.00208 18.9767 3.39131C18.895 3.78053 18.6991 4.13658 18.4141 4.41396L12.8282 9.99989L18.4141 15.5858C18.6061 15.7701 18.7593 15.9909 18.8649 16.2351C18.9705 16.4794 19.0262 16.7422 19.0289 17.0083C19.0317 17.2744 18.9812 17.5383 18.8807 17.7847C18.7801 18.0311 18.6314 18.2549 18.4432 18.443C18.255 18.6312 18.0312 18.7799 17.7849 18.8805C17.5385 18.9811 17.2746 19.0315 17.0085 19.0288C16.7424 19.0261 16.4796 18.9703 16.2353 18.8647C15.991 18.7591 15.7703 18.6059 15.586 18.414L10.0001 12.828L4.41414 18.414C4.22985 18.6059 4.00911 18.7592 3.76485 18.8647C3.5206 18.9703 3.25773 19.0261 2.99165 19.0288C2.72556 19.0315 2.46162 18.9811 2.21526 18.8805C1.96891 18.7799 1.74509 18.6312 1.55694 18.443C1.36878 18.2549 1.22005 18.0311 1.11948 17.7847C1.0189 17.5384 0.968487 17.2744 0.971195 17.0083C0.973904 16.7422 1.02968 16.4794 1.13525 16.2351C1.24082 15.9909 1.39407 15.7701 1.58602 15.5858L7.17195 9.99989L1.58602 4.41396C1.29701 4.13303 1.09961 3.77135 1.0197 3.37631C0.939777 2.98127 0.981064 2.5713 1.13815 2.20013C1.29523 1.82896 1.56078 1.5139 1.9 1.29624C2.23921 1.07858 2.63627 0.968481 3.03914 0.980362C3.55874 0.995844 4.0519 1.213 4.41414 1.58583L10.0001 7.17177L15.586 1.58583C15.7726 1.39401 15.9958 1.24158 16.2424 1.13758C16.489 1.03358 16.7539 0.980116 17.0216 0.980362Z"
      fill="white"
      fillOpacity="0.1"
    />
  </svg>
);

const FlatRoofIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.09 22C27.6423 22 28.09 21.5523 28.09 21C28.09 20.4477 27.6423 20 27.09 20C26.5377 20 26.09 20.4477 26.09 21C26.09 21.5523 26.5377 22 27.09 22Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 18C27.6423 18 28.09 17.5523 28.09 17C28.09 16.4477 27.6423 16 27.09 16C26.5377 16 26.09 16.4477 26.09 17C26.09 17.5523 26.5377 18 27.09 18Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 14C27.6423 14 28.09 13.5523 28.09 13C28.09 12.4477 27.6423 12 27.09 12C26.5377 12 26.09 12.4477 26.09 13C26.09 13.5523 26.5377 14 27.09 14Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 10C27.6423 10 28.09 9.55228 28.09 9C28.09 8.44772 27.6423 8 27.09 8C26.5377 8 26.09 8.44772 26.09 9C26.09 9.55228 26.5377 10 27.09 10Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 20C2.89222 20 2.69888 20.0586 2.53443 20.1685C2.36998 20.2784 2.2418 20.4346 2.16612 20.6173C2.09043 20.8 2.07063 21.0011 2.10921 21.1951C2.1478 21.3891 2.24304 21.5673 2.38289 21.7071C2.52274 21.847 2.70093 21.9422 2.89491 21.9808C3.08889 22.0194 3.28995 21.9996 3.47268 21.9239C3.65541 21.8482 3.81158 21.72 3.92147 21.5556C4.03135 21.3911 4.09 21.1978 4.09 21C4.09 20.7348 3.98464 20.4804 3.7971 20.2929C3.60957 20.1054 3.35521 20 3.09 20Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 18C3.64228 18 4.09 17.5523 4.09 17C4.09 16.4477 3.64228 16 3.09 16C2.53771 16 2.09 16.4477 2.09 17C2.09 17.5523 2.53771 18 3.09 18Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 14C3.64228 14 4.09 13.5523 4.09 13C4.09 12.4477 3.64228 12 3.09 12C2.53771 12 2.09 12.4477 2.09 13C2.09 13.5523 2.53771 14 3.09 14Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 10C3.64228 10 4.09 9.55228 4.09 9C4.09 8.44772 3.64228 8 3.09 8C2.53771 8 2.09 8.44772 2.09 9C2.09 9.55228 2.53771 10 3.09 10Z"
      fill="#D4D4DB"
    />
    <path
      d="M28.09 7H2.09C1.82478 7 1.57043 7.10536 1.38289 7.29289C1.19535 7.48043 1.09 7.73478 1.09 8C1.09 8.26522 1.19535 8.51957 1.38289 8.70711C1.57043 8.89464 1.82478 9 2.09 9H28.09C28.3552 9 28.6096 8.89464 28.7971 8.70711C28.9846 8.51957 29.09 8.26522 29.09 8C29.09 7.73478 28.9846 7.48043 28.7971 7.29289C28.6096 7.10536 28.3552 7 28.09 7V7Z"
      fill={lineColor}
    />
  </svg>
);

const FloorIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 26.02C27.5523 26.02 28 25.5723 28 25.02C28 24.4677 27.5523 24.02 27 24.02C26.4477 24.02 26 24.4677 26 25.02C26 25.5723 26.4477 26.02 27 26.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 24.02H3C2.73478 24.02 2.48043 24.1254 2.29289 24.3129C2.10536 24.5004 2 24.7548 2 25.02C2 25.2852 2.10536 25.5396 2.29289 25.7271C2.48043 25.9147 2.73478 26.02 3 26.02H27C27.2652 26.02 27.5196 25.9147 27.7071 25.7271C27.8946 25.5396 28 25.2852 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z"
      fill={lineColor}
    />
  </svg>
);

const InfoIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.52832C4.0238 0.52832 0.800003 3.75212 0.800003 7.72832C0.800003 11.7045 4.0238 14.9283 8 14.9283C11.9762 14.9283 15.2 11.7045 15.2 7.72832C15.2 3.75212 11.9762 0.52832 8 0.52832ZM8.6 11.3283H7.4V7.12832H8.6V11.3283ZM8 5.62832C7.5032 5.62832 7.1 5.22512 7.1 4.72832C7.1 4.23152 7.5032 3.82832 8 3.82832C8.4968 3.82832 8.9 4.23152 8.9 4.72832C8.9 5.22512 8.4968 5.62832 8 5.62832Z"
      fill="#6E7188"
    />
  </svg>
);

const InfoIconBig = ({ onClick }: { onClick: () => void }) => (
  <UnstyledButton onClick={onClick}>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1737_2)">
        <path d="M31 0H5C2.23858 0 0 2.23858 0 5V31C0 33.7614 2.23858 36 5 36H31C33.7614 36 36 33.7614 36 31V5C36 2.23858 33.7614 0 31 0Z" fill="#D52B1E" />
        <path d="M16.75 12.375C16.75 12.7065 16.8817 13.0245 17.1161 13.2589C17.3505 13.4933 17.6685 13.625 18 13.625C18.3315 13.625 18.6495 13.4933 18.8839 13.2589C19.1183 13.0245 19.25 12.7065 19.25 12.375C19.25 12.0435 19.1183 11.7255 18.8839 11.4911C18.6495 11.2567 18.3315 11.125 18 11.125C17.6685 11.125 17.3505 11.2567 17.1161 11.4911C16.8817 11.7255 16.75 12.0435 16.75 12.375ZM18.625 15.6562H17.375C17.2891 15.6562 17.2188 15.7266 17.2188 15.8125V24.875C17.2188 24.9609 17.2891 25.0312 17.375 25.0312H18.625C18.7109 25.0312 18.7812 24.9609 18.7812 24.875V15.8125C18.7812 15.7266 18.7109 15.6562 18.625 15.6562Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_1737_2">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </UnstyledButton>
)

const InnerWallIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 24.02C26.8022 24.02 26.6089 24.0787 26.4444 24.1885C26.28 24.2984 26.1518 24.4546 26.0761 24.6373C26.0004 24.8201 25.9806 25.0211 26.0192 25.2151C26.0578 25.4091 26.153 25.5873 26.2929 25.7271C26.4327 25.867 26.6109 25.9622 26.8049 26.0008C26.9989 26.0394 27.2 26.0196 27.3827 25.9439C27.5654 25.8682 27.7216 25.74 27.8315 25.5756C27.9414 25.4111 28 25.2178 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 26.02V13.02C27 12.7548 26.8946 12.5004 26.7071 12.3129C26.5196 12.1254 26.2652 12.02 26 12.02C25.7348 12.02 25.4804 12.1254 25.2929 12.3129C25.1054 12.5004 25 12.7548 25 13.02V25.02C25 25.2852 25.1054 25.5396 25.2929 25.7271C25.4804 25.9147 25.7348 26.02 26 26.02H27Z"
      fill={lineColor}
    />
    <path
      d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z"
      fill="#D4D4DB"
    />
  </svg>
);

const MouseIcon = () => (
  <svg
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.477 0 0 4.477 0 10V16C0 21.523 4.477 26 10 26C15.523 26 20 21.523 20 16V10C20 4.477 15.523 0 10 0ZM17 13H3C2.448 13 2 12.552 2 12C2 11.448 2.448 11 3 11H9V3C9 2.448 9.448 2 10 2C10.552 2 11 2.448 11 3V11H17C17.552 11 18 11.448 18 12C18 12.552 17.552 13 17 13Z"
      fill="white"
    />
  </svg>
);

const MouseScrollIcon = () => (
  <svg
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.477 0 0 4.477 0 10V16C0 21.523 4.477 26 10 26C15.523 26 20 21.523 20 16V10C20 4.477 15.523 0 10 0ZM13 12L10 15L7 12H9V6H7L10 3L13 6H11V12H13Z"
      fill="white"
    />
  </svg>
);

const OuterWallIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 24.02C2.80222 24.02 2.60888 24.0787 2.44443 24.1885C2.27998 24.2984 2.15181 24.4546 2.07612 24.6373C2.00043 24.8201 1.98063 25.0211 2.01922 25.2151C2.0578 25.4091 2.15304 25.5873 2.29289 25.7271C2.43275 25.867 2.61093 25.9622 2.80491 26.0008C2.99889 26.0394 3.19996 26.0196 3.38268 25.9439C3.56541 25.8682 3.72159 25.74 3.83147 25.5756C3.94135 25.4111 4 25.2178 4 25.02C4 24.7548 3.89464 24.5004 3.70711 24.3129C3.51957 24.1254 3.26522 24.02 3 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 22.02C3.55228 22.02 4 21.5723 4 21.02C4 20.4677 3.55228 20.02 3 20.02C2.44772 20.02 2 20.4677 2 21.02C2 21.5723 2.44772 22.02 3 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 18.02C3.55228 18.02 4 17.5723 4 17.02C4 16.4677 3.55228 16.02 3 16.02C2.44772 16.02 2 16.4677 2 17.02C2 17.5723 2.44772 18.02 3 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M3 14.02C3.55228 14.02 4 13.5723 4 13.02C4 12.4677 3.55228 12.02 3 12.02C2.44772 12.02 2 12.4677 2 13.02C2 13.5723 2.44772 14.02 3 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 24.02C26.8022 24.02 26.6089 24.0787 26.4444 24.1885C26.28 24.2984 26.1518 24.4546 26.0761 24.6373C26.0004 24.8201 25.9806 25.0211 26.0192 25.2151C26.0578 25.4091 26.153 25.5873 26.2929 25.7271C26.4327 25.867 26.6109 25.9622 26.8049 26.0008C26.9989 26.0394 27.2 26.0196 27.3827 25.9439C27.5654 25.8682 27.7216 25.74 27.8315 25.5756C27.9414 25.4111 28 25.2178 28 25.02C28 24.7548 27.8946 24.5004 27.7071 24.3129C27.5196 24.1254 27.2652 24.02 27 24.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 22.02C27.5523 22.02 28 21.5723 28 21.02C28 20.4677 27.5523 20.02 27 20.02C26.4477 20.02 26 20.4677 26 21.02C26 21.5723 26.4477 22.02 27 22.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 18.02C27.5523 18.02 28 17.5723 28 17.02C28 16.4677 27.5523 16.02 27 16.02C26.4477 16.02 26 16.4677 26 17.02C26 17.5723 26.4477 18.02 27 18.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M27 14.02C27.5523 14.02 28 13.5723 28 13.02C28 12.4677 27.5523 12.02 27 12.02C26.4477 12.02 26 12.4677 26 13.02C26 13.5723 26.4477 14.02 27 14.02Z"
      fill="#D4D4DB"
    />
    <path
      d="M29 25.02V12.02H28C27.7348 12.02 27.4804 12.1254 27.2929 12.3129C27.1054 12.5004 27 12.7548 27 13.02V26.02H28C28.2652 26.02 28.5196 25.9147 28.7071 25.7271C28.8946 25.5396 29 25.2852 29 25.02Z"
      fill={lineColor}
    />
    <path
      d="M28 13.02C28.2191 13.0199 28.4321 12.9479 28.6063 12.815C28.7805 12.6821 28.9062 12.4957 28.9641 12.2844C29.0221 12.0731 29.009 11.8487 28.927 11.6455C28.8449 11.4424 28.6984 11.2718 28.51 11.16L15.58 2.2C15.4069 2.07018 15.1964 2 14.98 2C14.7636 2 14.5531 2.07018 14.38 2.2L9.00001 5.96V5.02C9.00001 4.75478 8.89465 4.50043 8.70712 4.31289C8.51958 4.12536 8.26523 4.02 8.00001 4.02H7.00001C6.7348 4.02 6.48044 4.12536 6.2929 4.31289C6.10537 4.50043 6.00001 4.75478 6.00001 5.02V8.02L1.49001 11.16C1.3016 11.2718 1.15511 11.4424 1.07307 11.6455C0.991025 11.8487 0.977967 12.0731 1.0359 12.2844C1.09384 12.4957 1.21956 12.6821 1.39374 12.815C1.56792 12.9479 1.78092 13.0199 2.00001 13.02H28Z"
      fill="#D4D4DB"
    />
  </svg>
);

const RadioCheckedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="9"
      fill="white"
      stroke="#E30612"
      strokeWidth="2"
    />
    <rect
      width="13.3333"
      height="13.3333"
      rx="6.66667"
      transform="matrix(-1 0 0 1 16.6667 3.3335)"
      fill="#E30612"
    />
  </svg>
);

const RadioUncheckedIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1.72852"
      width="18"
      height="18"
      rx="9"
      fill="white"
      stroke="#6E7188"
      strokeWidth="2"
    />
  </svg>
);

const SloperRoofIcon = ({ lineColor }: { lineColor: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.09 25.9C27.6423 25.9 28.09 25.4523 28.09 24.9C28.09 24.3477 27.6423 23.9 27.09 23.9C26.5377 23.9 26.09 24.3477 26.09 24.9C26.09 25.4523 26.5377 25.9 27.09 25.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 21.9C27.6423 21.9 28.09 21.4523 28.09 20.9C28.09 20.3477 27.6423 19.9 27.09 19.9C26.5377 19.9 26.09 20.3477 26.09 20.9C26.09 21.4523 26.5377 21.9 27.09 21.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 17.9C27.6423 17.9 28.09 17.4523 28.09 16.9C28.09 16.3477 27.6423 15.9 27.09 15.9C26.5377 15.9 26.09 16.3477 26.09 16.9C26.09 17.4523 26.5377 17.9 27.09 17.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.09 13.9C27.6423 13.9 28.09 13.4523 28.09 12.9C28.09 12.3477 27.6423 11.9 27.09 11.9C26.5377 11.9 26.09 12.3477 26.09 12.9C26.09 13.4523 26.5377 13.9 27.09 13.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 23.9C2.89222 23.9 2.69888 23.9587 2.53443 24.0686C2.36998 24.1784 2.2418 24.3346 2.16612 24.5173C2.09043 24.7001 2.07063 24.9011 2.10921 25.0951C2.1478 25.2891 2.24304 25.4673 2.38289 25.6071C2.52274 25.747 2.70093 25.8422 2.89491 25.8808C3.08889 25.9194 3.28995 25.8996 3.47268 25.8239C3.65541 25.7482 3.81158 25.62 3.92147 25.4556C4.03135 25.2911 4.09 25.0978 4.09 24.9C4.09 24.6348 3.98464 24.3805 3.7971 24.1929C3.60957 24.0054 3.35521 23.9 3.09 23.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 21.9C3.64228 21.9 4.09 21.4523 4.09 20.9C4.09 20.3477 3.64228 19.9 3.09 19.9C2.53771 19.9 2.09 20.3477 2.09 20.9C2.09 21.4523 2.53771 21.9 3.09 21.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 17.9C3.64228 17.9 4.09 17.4523 4.09 16.9C4.09 16.3477 3.64228 15.9 3.09 15.9C2.53771 15.9 2.09 16.3477 2.09 16.9C2.09 17.4523 2.53771 17.9 3.09 17.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M3.09 13.9C3.64228 13.9 4.09 13.4523 4.09 12.9C4.09 12.3477 3.64228 11.9 3.09 11.9C2.53771 11.9 2.09 12.3477 2.09 12.9C2.09 13.4523 2.53771 13.9 3.09 13.9Z"
      fill="#D4D4DB"
    />
    <path
      d="M27.9997 13.02C28.2188 13.0199 28.4318 12.9479 28.606 12.815C28.7802 12.6821 28.9059 12.4957 28.9638 12.2844C29.0217 12.0731 29.0087 11.8487 28.9267 11.6455C28.8446 11.4424 28.6981 11.2718 28.5097 11.16L15.5797 2.2C15.4066 2.07018 15.1961 2 14.9797 2C14.7633 2 14.5528 2.07018 14.3797 2.2L8.99971 5.96V5.02C8.99971 4.75478 8.89435 4.50043 8.70681 4.31289C8.51928 4.12536 8.26492 4.02 7.99971 4.02H6.99971C6.73449 4.02 6.48014 4.12536 6.2926 4.31289C6.10506 4.50043 5.99971 4.75478 5.99971 5.02V8.02L1.48971 11.16C1.30129 11.2718 1.1548 11.4424 1.07276 11.6455C0.99072 11.8487 0.977662 12.0731 1.0356 12.2844C1.09353 12.4957 1.21925 12.6821 1.39343 12.815C1.56761 12.9479 1.78062 13.0199 1.99971 13.02H27.9997Z"
      fill="#D4D4DB"
    />
    <line
      x1="15.3978"
      y1="2.78496"
      x2="28.785"
      y2="12.6022"
      stroke={lineColor}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const UncheckedIcon = styled(UnstyledButton)`
  width: 20px;
  height: 20px;
  border: 1px solid ${styles.colors.darkBlue};
  border-radius: 4px;
  background: ${styles.colors.white};
`;

const SwiperIcon = ({ color }: { color: string }) => (
  <svg
    style={{ cursor: "pointer" }}
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8163 18.1486C14.9016 18.7614 11.6843 19.6408 9.26033 20.3677L6.54248 18.3292C6.20775 18.0799 5.73476 18.1464 5.48466 18.4803C5.2338 18.8143 5.3018 19.288 5.63577 19.5381L8.20024 21.4617L6.94294 24.7053C6.79182 25.0936 6.98526 25.5311 7.37438 25.683C7.4643 25.7177 7.55648 25.7336 7.64715 25.7336C7.95014 25.7336 8.23575 25.5507 8.35212 25.2508L9.68271 21.8183C12.0613 21.1043 15.2181 20.2415 19.0505 19.6424C19.4623 19.5774 19.7441 19.1905 19.6799 18.7788C19.6157 18.3662 19.2311 18.0897 18.8163 18.1486ZM50.6666 21.9415C50.6651 21.8538 50.65 21.767 50.6175 21.6831L49.1539 17.9054C49.0028 17.5155 48.5668 17.3228 48.1762 17.4732C47.787 17.625 47.5936 18.0625 47.7447 18.4509L48.6046 20.6707C46.5222 19.962 42.5138 18.781 37.171 18.0497C36.7539 17.9968 36.3761 18.2831 36.3195 18.6964C36.2628 19.1097 36.5522 19.4905 36.9655 19.5479C42.3566 20.2846 46.4081 21.5154 48.3484 22.1848L46.4376 23.6181C46.1036 23.8681 46.0356 24.3419 46.2864 24.6758C46.4345 24.8738 46.6612 24.978 46.8917 24.978C47.0496 24.978 47.2083 24.9289 47.3435 24.8269L50.3659 22.5603C50.3848 22.5459 50.3953 22.527 50.4127 22.5119C50.4482 22.4794 50.483 22.447 50.5124 22.4084C50.5344 22.3782 50.551 22.3465 50.5691 22.314C50.5827 22.2898 50.6001 22.2709 50.6107 22.246C50.6144 22.2346 50.6137 22.2233 50.6167 22.212C50.6424 22.1425 50.6553 22.0707 50.6598 21.9966C50.6605 21.9778 50.6666 21.9596 50.6666 21.9415ZM8.20024 9.37295L6.94294 12.6165C6.79182 13.0049 6.98526 13.4423 7.37438 13.5942C7.4643 13.629 7.55648 13.6448 7.64715 13.6448C7.95014 13.6448 8.23575 13.462 8.35212 13.162L9.68271 9.72806C12.6053 8.84558 19.5318 6.84489 28.0012 6.84489C37.7982 6.84489 45.4387 9.09718 48.3477 10.096L46.4376 11.5293C46.1036 11.7794 46.0356 12.2531 46.2864 12.5871C46.4345 12.785 46.6612 12.8893 46.8917 12.8893C47.0496 12.8893 47.2083 12.8402 47.3435 12.7382L50.3659 10.4715C50.3848 10.4572 50.3953 10.4383 50.4127 10.4232C50.4482 10.3907 50.483 10.3582 50.5124 10.3197C50.5344 10.2894 50.551 10.2577 50.5691 10.2252C50.5827 10.201 50.6001 10.1821 50.6107 10.1572C50.6144 10.1459 50.6137 10.1345 50.6167 10.1232C50.6424 10.0537 50.6553 9.98192 50.6598 9.90788C50.6605 9.88899 50.6666 9.87086 50.6666 9.85273C50.6651 9.76508 50.65 9.67819 50.6175 9.59433L49.1539 5.81659C49.0028 5.42673 48.5668 5.23406 48.1762 5.38442C47.787 5.53628 47.5936 5.97374 47.7447 6.36209L48.6038 8.57963C45.444 7.5007 37.8654 5.33379 28.0012 5.33379C20.1189 5.33379 13.5883 6.9824 9.25958 8.27892L6.54248 6.24045C6.20775 5.99036 5.73476 6.05761 5.48466 6.39156C5.2338 6.72551 5.3018 7.19924 5.63577 7.44933L8.20024 9.37295ZM31.0235 21.9558C31.0235 20.2891 29.668 18.9337 28.0012 18.9337C26.3344 18.9337 24.9788 20.2891 24.9788 21.9558V26.7377C25.5372 26.9379 26.6192 27.2447 28.0012 27.2447C29.3945 27.2447 30.4682 26.9402 31.0235 26.7392V21.9558ZM32.5347 21.9558V27.2447C32.5347 27.531 32.373 27.7925 32.1169 27.9209C32.0481 27.9549 30.4183 28.7558 28.0012 28.7558C25.5841 28.7558 23.9535 27.9549 23.8847 27.9209C23.6294 27.7925 23.4677 27.531 23.4677 27.2447V21.9558C23.4677 19.4557 25.501 17.4226 28.0012 17.4226C30.5007 17.4226 32.5347 19.4557 32.5347 21.9558ZM30.268 46.1334H25.7344C25.3173 46.1334 24.9788 46.4711 24.9788 46.8889C24.9788 47.3067 25.3173 47.6445 25.7344 47.6445H30.268C30.685 47.6445 31.0235 47.3067 31.0235 46.8889C31.0235 46.4711 30.685 46.1334 30.268 46.1334ZM30.268 49.1556H25.7344C25.3173 49.1556 24.9788 49.4933 24.9788 49.9111C24.9788 50.3289 25.3173 50.6667 25.7344 50.6667H30.268C30.685 50.6667 31.0235 50.3289 31.0235 49.9111C31.0235 49.4933 30.685 49.1556 30.268 49.1556ZM35.5571 21.9558V49.9111C35.5571 50.3289 35.2186 50.6667 34.8015 50.6667C34.3836 50.6667 34.0459 50.3289 34.0459 49.9111V21.9558C34.0459 18.6231 31.3341 15.9115 28.0012 15.9115C24.6683 15.9115 21.9565 18.6231 21.9565 21.9558V49.9111C21.9565 50.3289 21.618 50.6667 21.2009 50.6667C20.7838 50.6667 20.4453 50.3289 20.4453 49.9111V21.9558C20.4453 17.7898 23.8349 14.4004 28.0012 14.4004C32.1668 14.4004 35.5571 17.7898 35.5571 21.9558Z"
      fill={color}
    />
  </svg>
);

const ModelIcon = () => (
  <svg
    style={{ cursor: "pointer" }}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.3925 15.1555L21.4376 10.1345C21.2864 10.0464 21.1148 10 20.9401 10C20.7655 10 20.5939 10.0464 20.4426 10.1345L11.4877 15.1555C11.3361 15.2471 11.2111 15.3775 11.1255 15.5336C11.0399 15.6896 10.9967 15.8657 11.0002 16.0441V26.0811C11.0015 26.26 11.0501 26.4353 11.1411 26.5889C11.2321 26.7425 11.362 26.8688 11.5176 26.9547L20.4725 31.9756C20.6179 32.0606 20.7821 32.1072 20.9501 32.1111C21.1211 32.1067 21.2885 32.0602 21.4376 31.9756L30.3925 26.9547C30.546 26.8685 30.674 26.7426 30.7632 26.5899C30.8524 26.4372 30.8996 26.2632 30.9 26.086V16.0441C30.9015 15.8638 30.8552 15.6863 30.766 15.5301C30.6768 15.3739 30.5479 15.2445 30.3925 15.1555ZM19.9551 29.3949L12.9902 25.4886V17.7362L19.9551 21.6425V29.3949ZM20.9501 19.9053L14.0449 16.0441L20.9501 12.163L27.8553 16.0392L20.9501 19.9053ZM28.91 25.4886L21.9451 29.3949V21.6425L28.91 17.7362V25.4886Z"
      fill="none"
    />
  </svg>
);

const ConfiguratorIcon = () => (
  <svg
    style={{ cursor: "pointer" }}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="7" y="12" width="28" height="3.11111" rx="1.55556" fill="none" />
    <rect
      x="7"
      y="19.7778"
      width="28"
      height="3.11111"
      rx="1.55556"
      fill="none"
    />
    <rect
      x="7"
      y="27.5556"
      width="28"
      height="3.11111"
      rx="1.55556"
      fill="none"
    />
  </svg>
);


const ClipboardIcon = ({ checked }: { checked: boolean }) => (
  <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 3H16C16.2652 3 16.5196 3.10536 16.7071 3.29289C16.8946 3.48043 17 3.73478 17 4V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H7M7 6H13M8 2V6H12V2H8Z" stroke="#E30612" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    {checked &&
      <path d="M7 13L9 15L13 11" stroke="#E30612" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    }
  </svg>
);

const FloppyDiskIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21H7M17 21H17.803C18.921 21 19.48 21 19.907 20.782C20.284 20.59 20.59 20.284 20.782 19.908C21 19.481 21 18.921 21 17.803V9.22C21 8.77 21 8.545 20.952 8.331C20.9094 8.14009 20.8389 7.95647 20.743 7.786C20.637 7.596 20.487 7.431 20.193 7.104L17.438 4.042C17.097 3.664 16.924 3.472 16.717 3.334C16.5303 3.21013 16.3241 3.11853 16.107 3.063C15.863 3 15.6 3 15.075 3H6.2C5.08 3 4.52 3 4.092 3.218C3.71569 3.40974 3.40974 3.71569 3.218 4.092C3 4.52 3 5.08 3 6.2V17.8C3 18.92 3 19.48 3.218 19.907C3.41 20.284 3.715 20.59 4.092 20.782C4.519 21 5.079 21 6.197 21H7M17 21V17.197C17 16.079 17 15.519 16.782 15.092C16.59 14.7155 16.2837 14.4096 15.907 14.218C15.48 14 14.92 14 13.8 14H10.2C9.08 14 8.52 14 8.092 14.218C7.71569 14.4097 7.40974 14.7157 7.218 15.092C7 15.52 7 16.08 7 17.2V21M15 7H9" stroke="#E30612" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
